import React from "react";
import { isNil } from "lodash";

import { getUpns } from "@modules/datasheets/services/datasheet";

import { Tabs, TabsItemOnOrderChange, TabsProps } from "../tabs";
import { Header } from "./components/header";
import { ResultProps, useDatasheetResultMainController } from "./controllers/main";
import { Datasheet } from "./components/datasheet";
import { DatasheetPrintingSettings } from "../datasheet-printing-settings";

import './result.styles.scss';

export const Result: React.FC<ResultProps> = (props) => {
  const {
    handleDatasheetElementsRedo,
    handleDatasheetElementsUndo,
    canRedo,
    canUndo,
    datasheet,
    currentTabId,
    handleSelectedTabChange,
    handleTabOrderChange,
    handleUpnChange,
    currentUpn,
    datasheetElementsProcessed,
    pageBreaks,
    gridSettingsMargin,
    updateDatasheetElement,
    handlePrintDatasheetElements,
    handlePrintingSettingsClose,
    printingSettingsOpened,
    calculatePaperCount,
    handlePrintWithPageSkip,
    printableDatasheetHolderId,
    getDatasheetFolderFormats,
    getFoldersForDatasheet
  } = useDatasheetResultMainController(props);


  return (
    <div className="DatasheetsResult">
      <Header
        disabledState={{
          print: false,
          undo: !canUndo,
          redo: !canRedo,
          orderTest: false,
          generateLetter: false,
          testResults: false,
        }}
        className="DatasheetsResult__header"
        upn={currentUpn}
        onUpnChange={handleUpnChange}
        getUpns={getUpns}
        onPrint={handlePrintDatasheetElements}
        onUndo={handleDatasheetElementsUndo}
        onRedo={handleDatasheetElementsRedo}
        onOrderTest={() => {}}
        onGenerateLetter={() => {}}
        onOrderTestResults={() => {}}
        getDatasheetFolderFormats={getDatasheetFolderFormats}
        getFoldersForDatasheet={getFoldersForDatasheet}
        onDatasheetFormatsSubmit={() => {}}
      />
      <div className="DatasheetsResult__content">
        {!isNil(currentTabId) && (
          <Tabs
            items={datasheet.tabs}
            value={currentTabId}
            onChange={handleSelectedTabChange as TabsProps["onChange"]}
            classes={{
              tabs: "DatasheetsResult__content__tabs",
            }}
            onTabOrderChange={handleTabOrderChange as TabsItemOnOrderChange}
          />
        )}
        {printingSettingsOpened && (
          <DatasheetPrintingSettings
            onClose={handlePrintingSettingsClose}
            calculatePaperCount={calculatePaperCount}
            onSubmit={handlePrintWithPageSkip}
          />
        )}
        <Datasheet
          printableDatasheetHolderId={printableDatasheetHolderId}
          pageBreaks={pageBreaks}
          gridSettingsMargin={gridSettingsMargin}
          datasheet={datasheet}
          datasheetElements={datasheetElementsProcessed}
          onDatasheetElementUpdate={updateDatasheetElement}
          className="DatasheetsResult__content__datasheet"
        />
      </div>
    </div>
  );
};